module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_logistics-0aa70206fbdcba4c5f515b6ccd1a24cf.svg";